// extracted by mini-css-extract-plugin
export default {"form":"FiltersForm_form__M90Nu","footer":"FiltersForm_footer__xWmrd","footerBtn":"FiltersForm_footerBtn__2LLst"};